export default __webpack_public_path__ + "static/media/button_goback_ja.4aad395d.svg";